import { PREFERENCE_MANAGEMENT } from "constants/types";
const initialPreferenceState: any = {
  email: "",
  loading: true,
};
export const preferenceReducer = (state = initialPreferenceState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case PREFERENCE_MANAGEMENT.LOAD_PREFERENCES:
      newState["id"] = action.payload.id.toString();
      return newState;
    case PREFERENCE_MANAGEMENT.LOAD_SUCCESS_PREFERENCES:
      if (action.payload) {
        return { ...action.payload, id: newState.id };
      }
      return newState;
    case PREFERENCE_MANAGEMENT.LOAD_FAIL_PREFERENCES:
      return initialPreferenceState;
    case PREFERENCE_MANAGEMENT.CHANGE_UNSUBALL:
      if (newState["unsub_all"] === "1") {
        newState["unsub_all"] = "0";
      } else {
        newState["unsub_all"] = "1";
      }
      return newState;
    case PREFERENCE_MANAGEMENT.CHANGE_ACTION:
      if (action.payload.key === "news_letters" || action.payload.key === "alerts") {
        if (action.payload.id === undefined) {
          newState[action.payload.key].forEach((item: any) => {
            item.status = action.payload.value;
          });
        } else {
          newState[action.payload.key].forEach((item: any) => {
            if (action.payload.id === (item.id ?? item.name)) {
              item.status = action.payload.value;
            }
          });
        }
      } else {
        newState[action.payload.key] = action.payload.value;
      }
      return newState;
    default:
      return newState;
  }
};
